//state
export var adsAccState = {
  ads_accounts: [],
  status_ads_accounts: ""
};

//getters
export var adsAccGetters = {
  //funciones para optener informacion del state
  getAdsAccounts: state => state.ads_accounts
};

//actions
export var adsAccActions = {
  async getAdsAccounts({ commit }) {
    commit("ads_accounts_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.ad_account", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            '["name","id" ,"account_id", "account_status", "business_name",("business_account_id", ["id", "name"]),("partner_id", ("id", "name"))]'

        }
      })
      .then(res => {
        var adsAccounts = res.data;
        commit("ads_accounts_success", adsAccounts);
        return res;
      })
      .catch(err => {
        commit("ads_accounts_error");
        return err;
      });
  },
  async newAdsAccount({ commit, state }, adsAccount) {
    commit("page_request");
    var {
      name,
      account_id,
      account_status,
      business_account,
      partner

    } = adsAccount;
    var formData = new FormData();
    var new_adsAccount = `{
      'name':'${name}',
      'account_id':'${account_id}',
      'partner_id':'${partner.id}',
      'account_status': ${account_status.value},
      'business_account_id': '${business_account.id}',

      }`;
    formData.append("data", new_adsAccount);
    await this._vm.$http
      .post("/apache/rest_api/apache.ad_account", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          adsAccount.id = res.data.id;
          var adsAccounts = state.ads_accounts;
          adsAccount.account_status = parseInt(adsAccount.account_status.value) 
          adsAccount.partner_id = adsAccount.partner
          adsAccount.business_name = business_account.name
          adsAccount.business_account_id = business_account

          adsAccounts.push(adsAccount);
          commit("ads_accounts_success", adsAccounts);
          return adsAccounts;
        } else {
          commit("ads_accounts_error");
        }
      })
      .catch(err => {
        commit("ads_accounts_error");
        return err;
      });
  },
  async editAdsAccount({ commit, state }, adsAccount) {
    commit("page_request");
    var {
      id,
      name,
      account_id,
      account_status,
      business_account,
      partner
    } = adsAccount;
    var formData = new FormData();
    var new_adsAccount = `{
      'name':'${name}',
      'account_id':'${account_id}',
      'partner_id':'${partner.id}',
      'business_account_id': '${business_account.id}',
      'account_status': ${account_status.value},
    }`;
    formData.append("data", new_adsAccount);
    await this._vm.$http
      .put("/apache/rest_api/apache.ad_account", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          //adsAccount.id = res.data.id;
          var adsAccounts = state.ads_accounts;
          adsAccount.partner_id = adsAccount.partner
          adsAccount.business_name = business_account.name
          adsAccount.business_account_id = business_account
          var index;
          adsAccount.account_status = parseInt(adsAccount.account_status.value) 
          for (var i = 0; i < adsAccounts.length; i++) {
            if (adsAccounts[i].id == id) {
              index = i;
              adsAccounts[i] = adsAccount;
              break;
            }
          }
          adsAccounts.splice(index, 1);
          adsAccounts.splice(index, 0, adsAccount);
          commit("ads_accounts_success", adsAccounts);
          return adsAccounts;
        } else {
          commit("ads_accounts_error");
        }
      })
      .catch(err => {
        commit("ads_accounts_error");
        return err;
      });
  },
  async deleteAdAccount({ commit, state }, id) {
    commit("ads_accounts_request");
    await this._vm.$http
    .delete(`/apache/rest_api/apache.ad_account/${id}`, { 
      headers: {
      "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 210) {
          var adsAccounts = state.ads_accounts
          commit("ads_accounts_success", adsAccounts);
          return adsAccounts;
        } else {
          commit("ads_accounts_error");
        }
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  },
  async deleteAdAccountUtility({ commit, state }, id) {
    commit("ads_accounts_request");
    var index;
    var adsAccounts = state.ads_accounts;
    for (var i = 0; i < adsAccounts.length; i++) {
      if (adsAccounts[i].id == id) {
        index = i;
        break;
      }
    }
    adsAccounts.splice(index, 1);
    commit("ads_accounts_success", adsAccounts);
    return adsAccounts;
  },
};

//mutations

export var adsAccMutations = {
  ads_accounts_request(state) {
    state.status_ads_accounts = "loading";
  },
  ads_accounts_success(state, payload) {
    state.status_ads_accounts = "success";
    state.ads_accounts = payload;
  },
  ads_accounts_error(state) {
    state.status_ads_accounts = "error";
  }
};
